import preferences from "./preferences";

export default function* () {
    yield* [...preferences];
}
